import React from 'react';
import PropTypes from 'prop-types';
import { BoxscoreTabs } from './Boxscore.style';
import { TabsContext } from '@mlb/react-patterns/v4/components/Tabs/tabs';
import types from './boxscore//boxscoreTeam/config/TeamTypes';

const { AWAY } = types;

const TeamTabs = ({
    team,
    homeName,
    awayName,
    onClick,
    activeTab
}) => {

    const tablistWithHandlers = [];
    const tabHandler = {
        handlers: { onClick }
    };

    const tablist = [
        {
            name: awayName
        },
        {
            name: homeName
        }
    ];

    for (let i = 0; i < tablist.length; i++) {
        tablistWithHandlers[i] = { ...tablist[i], ...tabHandler };
    }
    return (
        <TabsContext initialActiveTab={tablist[activeTab]?.name} key={`boxscore-tabontext-${activeTab}`}>
            <BoxscoreTabs list={tablistWithHandlers} key={`boxscore-tab-${activeTab}`} />
        </TabsContext>
    );
};

TeamTabs.propTypes = {
    team: PropTypes.string,
    awayName: PropTypes.string,
    homeName: PropTypes.string,
    onClick: PropTypes.func,
    activeTab: PropTypes.number
};

export default TeamTabs;
